import { useRouter } from 'vue-router';
import home from './home';
import system from './system';
import helpDoc from './helpDoc';
import cms from './cms';

export interface MenuItemDto {
    name: string;
    title: string;
    icon: string;
    path: string;
    /** 不需要缓存 */
    noCache?: boolean;
    /** tab页不可关闭 永久显示 */
    allowShow?: boolean;
    /** 不需要在菜单中显示 */
    noMenu?: boolean;
    /** 父节点 name 主要用作面包屑关系 */
    parentName?: string;
    /** 是否需要权限控制（对应路由 name） */
    requiresPermission?: boolean;
    childList?: MenuItemDto[];
}

const routerList = [
    ...home,
    ...helpDoc,
    ...cms,
    ...system,
];

/**
 * 把路由设置 转化为菜单和面包屑以及tab页面所需的数据
 */
const getMenuList = () => {
    const menuList: MenuItemDto[] = [];
    const addMenuByRouterItem = (list: MenuItemDto[], item: any, basePath: string) => {
        const meta = item.meta as any;
        let path = basePath;
        if (item.path) {
            if (basePath === '/' && !item.path.startsWith('/')) {
                path = `/${item.path}`;
            } else if (basePath !== '/' && !item.path.startsWith('/')) {
                path = `${basePath}/${item.path}`;
            } else {
                path = `${basePath}${item.path}`;
            }
        }
        const menu: MenuItemDto = {
            name: item.name,
            title: meta.title,
            icon: meta.icon,
            path,
        };
        if (meta.noCache) menu.noCache = true;
        if (meta.noMenu) menu.noMenu = true;
        if (meta.allowShow) menu.allowShow = true;
        if (meta.parentName) menu.parentName = meta.parentName;
        if (meta.requiresPermission) menu.requiresPermission = true;

        if (item.children && item.children.length > 0) {
            menu.childList = [];
            item.children.forEach((child: any) => {
                addMenuByRouterItem(menu.childList!, child, path);
            });
        }
        list.push(menu);
    };
    routerList.forEach((list: any) => {
        if (!list.children) return;
        if (list.children.length === 1) {
            const item = list.children[0];
            addMenuByRouterItem(menuList, item, list.path);
        } else {
            const rootMeta = list.meta;
            const menuItem: MenuItemDto = {
                name: list.name,
                title: rootMeta.title,
                icon: rootMeta.icon,
                path: list.path,
                childList: [],
            };
            list.children.forEach((item: any) => {
                if (menuItem.childList) {
                    addMenuByRouterItem(menuItem.childList, item, list.path);
                }
            });
            menuList.push(menuItem);
        }
    });
    return menuList;
};
export const MenuList = getMenuList();

export const MenuMaps = (function () {
    const menuMaps = new Map();
    const traverse = (items: MenuItemDto[]) => {
        items.forEach((item) => {
            menuMaps.set(item.name, item);
            if (item.childList && item.childList.length > 0) {
                traverse(item.childList);
            }
        });
    };
    traverse(MenuList);
    return menuMaps;
})();

export const useCurrRouterHooks = () => {
    const router = useRouter();
    const item: MenuItemDto = MenuMaps.get(router.currentRoute.value.name);
    return item;
};

export default routerList;
